export default "__VITE_ASSET__Cgn92Ou___"